import { submit, isValid, isDirty } from 'redux-form';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as VendorLinkIntegrationSelectors from 'Pages/vendorlinkintegration/state/selectors';
import * as VendorLinkIntegrationActions from 'Pages/vendorlinkintegration/state/actions';
import { makeOptionsData, makeOptionsDataRemoveEmpty } from 'Common/FormHelper';
import { getLanguages } from 'Pages/importstudents/state/selectors';
import { VENDORLINK_MAPPINGS_FORM_NAME } from 'Common/FormEnum';
import { LoadingPage, NotificationMessage } from 'Components/';
import { errorToast } from 'Common/ToastHelper';
import { getSites } from 'State/selectors';
import { Main } from 'Containers/';

import { VendorLinkMappingForm } from './VendorLinkMappingForm';

export class VendorLinkMappingStepContainer extends Component {
  static stepInfo = {
    icon: 'map',
    title: 'Map',
    description: 'Configure VendorLink field mappings',
  };

  statusCodeOptions = [
    { key: 1, value: true, text: 'Active' },
    { key: 2, value: false, text: 'Inactive' },
  ];

  componentDidMount() {
    const { getData, getMappings } = this.props;
    getData();
    getMappings();
  }

  componentDidUpdate(prevProps) {
    const {
      getDataErrors,

      setMappingsResult,
      setMappingsErrors,
      clearSetMappingsResult,

      getMappingsResult,
      isMappingsValid,
      isMappingsDirty,

      stepCompleted,
      setStepCompleted,

      mpwSites,
      getMPWGrades,
    } = this.props;

    if (mpwSites && typeof prevProps.mpwSites === 'undefined') {
      getMPWGrades(mpwSites);
    }

    if (getDataErrors) {
      errorToast(this.props, prevProps, 'getDataErrors');
    }

    if (setMappingsResult || setMappingsErrors) {
      if (!errorToast(this.props, prevProps, 'setMappingsErrors')) {
        NotificationMessage({ Data: setMappingsResult, Errors: [] });
      }

      clearSetMappingsResult();
    }

    if (getMappingsResult && !isMappingsDirty && isMappingsValid) {
      if (!stepCompleted) {
        setStepCompleted(true);
      }
    } else if (stepCompleted) {
      setStepCompleted(false);
    }
  }

  onSubmit = values => {
    const {
      setMappings,

      clearPreviewData,
      clearPreviewSuccess,
      updatePreviewHasBeenRun,
    } = this.props;

    setMappings(values);

    clearPreviewData();
    clearPreviewSuccess();
    updatePreviewHasBeenRun(false);
  };

  /** generate toolbar buttons */
  getMainProps = () => {
    const {
      submit,
      isMappingsDirty,
      isMappingsValid,

      getMappingsLoading,
      setMappingsLoading,

      stepCompleted,
      goToPreviousStep,
      goToNextStep,
    } = this.props;

    const mainProps = {
      toolbox: {
        shown: true,
        backButtonProps: {
          shown: true,
          disabled: getMappingsLoading || setMappingsLoading || isMappingsDirty,
          callback: goToPreviousStep,
        },
        rightButtons: [
          {
            content: 'Save',
            loading: setMappingsLoading,
            disabled:
              getMappingsLoading || setMappingsLoading || !isMappingsDirty,
            onClick: () => submit(VENDORLINK_MAPPINGS_FORM_NAME),
          },
          {
            content: 'Next',
            disabled:
              getMappingsLoading ||
              setMappingsLoading ||
              !stepCompleted ||
              isMappingsDirty ||
              !isMappingsValid,
            onClick: goToNextStep,
          },
        ],
      },
    };

    return mainProps;
  };

  render() {
    const {
      getMappingsLoading,
      getMappingsResult,

      siteOptions,
      gradeOptions,
      languageOptions,
      siteSourceOptions,
    } = this.props;

    const { statusCodeOptions } = this;

    const mainProps = this.getMainProps();

    return getMappingsLoading ? (
      <LoadingPage />
    ) : (
      <Main {...mainProps}>
        <VendorLinkMappingForm
          initialValues={getMappingsResult}
          onSubmit={values => this.onSubmit(values)}
          siteOptions={siteOptions}
          gradeOptions={gradeOptions || []}
          languageOptions={languageOptions}
          statusCodeOptions={statusCodeOptions}
          siteSourceOptions={siteSourceOptions}
        />
      </Main>
    );
  }
}

const mapStateToProps = state => {
  return {
    getDataLoading: VendorLinkIntegrationSelectors.getDataLoading(state),
    getDataErrors: VendorLinkIntegrationSelectors.getDataErrors(state),

    getMappingsLoading: VendorLinkIntegrationSelectors.getMappingsLoading(
      state
    ),
    getMappingsResult: VendorLinkIntegrationSelectors.getMappingsResult(state),
    getMappingsErrors: VendorLinkIntegrationSelectors.getMappingsErrors(state),

    setMappingsLoading: VendorLinkIntegrationSelectors.setMappingsLoading(
      state
    ),
    setMappingsResult: VendorLinkIntegrationSelectors.setMappingsResult(state),
    setMappingsErrors: VendorLinkIntegrationSelectors.setMappingsErrors(state),

    mpwSites: VendorLinkIntegrationSelectors.getMPWSites(state),

    gradeOptions: makeOptionsData(
      VendorLinkIntegrationSelectors.getGradesResult(state),
      {
        keyKey: 'Id',
        valueKey: 'Id',
        textKeys: ['Id', 'Description'],
      }
    ),

    siteOptions: makeOptionsDataRemoveEmpty(
      getSites(state).filter(s => s.IsActive && s.IsLicensed),
      true
    ),
    languageOptions: makeOptionsData(getLanguages(state)),

    siteSourceOptions: makeOptionsDataRemoveEmpty(
      VendorLinkIntegrationSelectors.getSitesOptions(state),
      true
    ),

    isMappingsValid: isValid(VENDORLINK_MAPPINGS_FORM_NAME)(state),
    isMappingsDirty: isDirty(VENDORLINK_MAPPINGS_FORM_NAME)(state),
  };
};

const mapDispatchToProps = {
  getData: VendorLinkIntegrationActions.getData,

  getMPWGrades: VendorLinkIntegrationActions.getGrades,
  getMappings: VendorLinkIntegrationActions.getMappings,

  setMappings: VendorLinkIntegrationActions.setMappings,
  clearSetMappingsResult: VendorLinkIntegrationActions.clearSetMappingsResult,

  clearPreviewData: VendorLinkIntegrationActions.clearPreviewData,
  clearPreviewSuccess: VendorLinkIntegrationActions.clearPreviewSuccess,
  updatePreviewHasBeenRun: VendorLinkIntegrationActions.updatePreviewHasBeenRun,

  submit,
};

export const VendorLinkMappingStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorLinkMappingStepContainer);



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/components/VendorLinkMappingStep/VendorLinkMappingStep.js